var map = {
	"./login.png": "2493",
	"./mannul_close_home.png": "efe7",
	"./mannul_home_add.png": "dc40",
	"./mannul_home_creadeQR.png": "2034",
	"./mannul_home_edit-openclose.png": "6065",
	"./mannul_home_editdelete.png": "8415",
	"./mannul_news_add-1.png": "6b2c",
	"./mannul_news_add-2.png": "9bf4",
	"./mannul_news_editdelete.png": "076e",
	"./mannul_request_help-status.png": "abf0",
	"./mannul_request_help.png": "7bfb",
	"./mannul_transactions_dateil.png": "5530",
	"./mannul_transactions_export-excel.png": "0dfd",
	"./mannul_transactions_search.png": "4dc4",
	"./mannul_vip.png": "a6e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d682";